import {
  Page,
  PageContent,
  PageType,
  pageContentSchema,
  pageContentsSchema,
  pagesSchema,
} from "@boark/shared/types/page";

import { getId } from "../utils/id";
import { request } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getPages(language: string) {
  return request(`${API_BASE_URL}/page`, {
    schema: pagesSchema,
    headers: {
      "Accept-Language": language,
    },
  });
}

export async function searchPages(query: string, language: string) {
  return request(`${API_BASE_URL}/page?query=${query}`, {
    schema: pageContentsSchema,
    headers: {
      "Accept-Language": language,
    },
  });
}

export async function getPage(
  id: string,
  language: string,
): Promise<PageContent> {
  const pageId = getId(id);

  return request(`${API_BASE_URL}/page/${pageId}`, {
    schema: pageContentSchema,
    headers: {
      "Accept-Language": language,
    },
  });
}

export function getSubPages(pages: Page[], slug: string): Page[] {
  const searchSlug = `${slug.slice(0, 1) !== "/" ? "/" : ""}${slug}${slug.slice(-1) !== "/" ? "/" : ""}`;

  return pages
    .filter((page) => page.slug.startsWith(searchSlug))
    .sort((a, b) => a.order - b.order);
}

export async function updatePage(
  id: string,
  language: string,
  {
    title,
    content,
    type,
  }: {
    title: string;
    content?: string;
    type?: PageType;
  },
): Promise<void> {
  const pageId = getId(id);

  await request(`${API_BASE_URL}/page/${pageId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": language,
    },
    body: { title, content, type },
  });
}
